import { Stack, Typography } from "@mui/material";
import { Fragment } from "react";

interface Props {
  title: string;
  properties: Array<[string, string]>;
}

const PropertyValue = ({ property }: { property: [string, string] }) => {
  const [label, value] = property;

  return (
    <>
      <Typography variant="caption" color="textSecondary">
        {label}:{" "}
      </Typography>
      <Typography variant="caption">{value}</Typography>
    </>
  );
};

const InlinePropertyBox = ({ title, properties }: Props) => {
  return (
    <Stack spacing={1} sx={{ p: 1.25, width: "100%", bgcolor: "background.grey" }}>
      <Typography variant="subtitle2" color="textSecondary">
        {title}
      </Typography>
      <Stack spacing={1} useFlexGap direction="row" sx={{ alignItems: "center", flexWrap: "wrap" }}>
        {properties.map((prop, i) => (
          <Fragment key={prop[0]}>
            <PropertyValue property={prop} />
            {i < properties.length - 1 && <Typography variant="caption">&bull;</Typography>}
          </Fragment>
        ))}
      </Stack>
    </Stack>
  );
};

export default InlinePropertyBox;
